import React, {FC} from "react"
import {MarkdownAtom, MarkdownBlock} from "../../model/markdown/MarkdownText"
import {AtomsViewer} from "../atoms/AtomsViewer"
import './MarkdownTable.less'

interface MarkdownTableProps {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownTable: FC<MarkdownTableProps> = ({
    block,
    onToggleCheckBox
}) => {
    const headerRows = block.atoms.filter(atom => atom.content === 'header')
    const dataRows = block.atoms.filter(atom => atom.content === 'data')

    if (headerRows.length === 0 && dataRows.length === 0) {
        return null
    }

    const columnCount = headerRows.length > 0
        ? headerRows[0].subAtoms.length
        : dataRows.length > 0 ? dataRows[0].subAtoms.length : 0

    if (columnCount === 0) {
        return null
    }

    return (
        <div className="block table">
            <table>
                {headerRows.length > 0 && (
                    <thead>
                        {headerRows.map(rowAtom => (
                            <tr key={rowAtom.id}>
                                {rowAtom.subAtoms.map((cellAtom, idx) => (
                                    <th key={cellAtom.id}>
                                        <AtomsViewer
                                            atoms={cellAtom.subAtoms}
                                            onToggleCheckBox={onToggleCheckBox}
                                        />
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                )}
                {dataRows.length > 0 && (
                    <tbody>
                        {dataRows.map(rowAtom => (
                            <tr key={rowAtom.id}>
                                {rowAtom.subAtoms.map(cellAtom => (
                                    <td key={cellAtom.id}>
                                        <AtomsViewer
                                            atoms={cellAtom.subAtoms}
                                            onToggleCheckBox={onToggleCheckBox}
                                        />
                                    </td>
                                ))}
                                {Array.from({ length: Math.max(0, columnCount - rowAtom.subAtoms.length) }).map((_, idx) => (
                                    <td key={`empty-${idx}`}></td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                )}
            </table>
        </div>
    )
}
